<template>
  <v-card>
    <v-list-item>
      <v-list-item-avatar class="dense-list-item">
        <v-icon
          small
          :color="arquivo.avatar.color"
          v-text="arquivo.avatar.icon"
        ></v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title
          class="text-body-2"
          v-text="arquivo.nome"
        ></v-list-item-title>
      </v-list-item-content>

      <v-list-item-action class="dense-list-item inline-itens">
        <v-btn
          icon
          color="blue darken-3"
          title="Download"
          @click="downloadArquivo()"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>

        <botao-excluir-com-confirmacao
          @confirm="removeArquivo()"
          ctexto="Tem certeza que deseja excluir esse Arquivo?"
        ></botao-excluir-com-confirmacao>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>
<style scoped>
.dense-list-item {
  padding: 0px;
  margin: 0px !important;
  min-height: 0px;
}
.inline-itens {
  flex-direction: row;
}
</style>
<script>
import * as ArquivoService from "@/services/arquivo.service";

export default {
  props: {
    arquivo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadArquivo() {
      this.$nprogress.start();
      ArquivoService.getOne(this.arquivo.id)
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", this.arquivo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      })
      .finally(() => {
        this.$nprogress.done();
      })
    },
    removeArquivo(){
      this.$emit("remover")
    }
  },
};
</script>
